"use strict";
// packages/contracts/src/conflito.ts — Fase 03, Plano 07 (OPS-05, D-01).
// Contratos para detecção e exibição dos conflitos no planejamento.
// movimento_concorrente (Fase 11, D-23) é o conflito do Kanban, separado do cronograma.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=conflito.js.map